import { toAppUrl } from './utils';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  basename: toAppUrl('/'),
});
export default history;
